import { Component } from '@angular/core';
import { LcsChipGridComponentBase } from 'src/app/common-components/chip-grid/chip-grid';
import { UserOption } from 'src/app/pages/user-register/models/user-option.interface';

@Component({
    selector: 'ndt-users-chip-grid',
    templateUrl: 'user-chip-grid.component.html',
    standalone: false
})
export class UserChipGridComponent extends LcsChipGridComponentBase<UserOption> {
   trackBy(item: UserOption | null) {
      return item?.userId;
   }
}
